/* Recherche par référence / SKU (contournement d'un comportement du moteur de recherche Shopify).
   1. envoie à Shopify les 10 premiers caractères quand le terme ressemble à une référence ;
   2. ne garde dans la recherche instantanée que les produits qui correspondent vraiment au terme tapé
      (pas de faux positif : une référence inexistante ne remonte rien) et réaffiche le terme complet ;
   3. à la validation (Entrée / bouton), ouvre directement la fiche s'il n'y a qu'un produit,
      sinon la page de résultats. */
      
(function () {
  if (window.bohmSearchRef) return;

  var PREFIX_LENGTH = 10;
  // Un seul mot, lettres + chiffres (tiret autorisé), plus de 10 caractères
  var REF_PATTERN = /^(?=[^\s]*\d)(?=[^\s]*[a-z])[a-z0-9-]{11,}$/i;

  function clean(term) {
    return (term || '').trim();
  }

  function isRef(term) {
    return REF_PATTERN.test(clean(term));
  }

  // Terme réellement envoyé à Shopify
  function query(term) {
    term = clean(term);
    return isRef(term) ? term.slice(0, PREFIX_LENGTH) : term;
  }

  // Le produit correspond-il à la référence tapée ? (handle = référence en minuscules, ou SKU affiché)
  function matches(term, handle, sku) {
    var t = clean(term).toLowerCase();
    handle = (handle || '').toLowerCase();
    sku = (sku || '').toLowerCase();
    return (handle && (handle.indexOf(t) === 0 || t.indexOf(handle) === 0)) || (sku && sku.indexOf(t) === 0);
  }

  function handleFromUrl(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  // Recherche instantanée : filtre les produits rendus par sections/livesearch.liquid
  function filterLive(container, term) {
    if (!container || !isRef(term)) return;

    var sent = query(term);
    Array.prototype.forEach.call(container.querySelectorAll('.l4ca.compact > li'), function (li) {
      var link = li.querySelector('a[href*="/products/"]');
      var ref = li.querySelector('.small');
      var sku = ref ? ref.textContent.replace(/^\s*REF:\s*/i, '').trim() : '';
      if (!matches(term, handleFromUrl(link && link.getAttribute('href')), sku)) li.remove();
    });

    var list = container.querySelector('.l4ca.compact');
    if (list && !list.children.length) list.remove();

    // « Résultats pour BM6708B070 » → « Résultats pour BM6708B0700 »
    var title = container.querySelector(':scope > div > p');
    if (title && title.textContent.indexOf(sent) !== -1) {
      title.textContent = title.textContent.replace(sent, clean(term));
    }
  }

  // Validation du formulaire : fiche produit directe si un seul produit correspond
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var input = form.querySelector('input[name="q"]');
    var action = form.getAttribute('action') || '';
    if (!input || action.indexOf('/search') === -1) return;

    var term = clean(input.value);
    if (!isRef(term) || form.__bohmRefResolved) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var root = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    fetch(root + '.json?q=' + encodeURIComponent(query(term)) + '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = ((data.resources || {}).results || {}).products || [];
        var found = products.filter(function (p) { return matches(term, p.handle, ''); });
        if (found.length === 1) {
          window.location.href = found[0].url;
        } else if (found.length > 1) {
          window.location.href = action + '?q=' + encodeURIComponent(query(term)) + '&type=product';
        } else {
          form.__bohmRefResolved = true; // aucune correspondance : recherche normale (« aucun résultat »)
          form.submit();
        }
      })
      .catch(function () {
        form.__bohmRefResolved = true;
        form.submit();
      });
  }, true);

  window.bohmSearchRef = { isRef: isRef, query: query, matches: matches, filterLive: filterLive };
})();